import View from 'mixins/view';
import OtherDayView from 'ui/matchCalendar/event/other-day-view';
import moment from 'moment/moment';

const elements = {
  container: '.c-calendar-other-days-container',
};

export default class extends View {
  constructor(model) {
    super(model);
    this.setRootEl($(elements.container));
  }
  hide() {
    this.rootEl.addClass('fn-hidden');
  }
  render() {
    this.rootEl.removeClass('fn-hidden');
    const count = this.model.get('matches').length - 1;
    const date = moment(this.model.get('day')).format('D MMMM YYYY');
    // to understand following HTML structure (especially
    // data-attributes) see 'ui/sliding-box.js' file.
    // I'm using previous component to implement collapsing
    this.rootEl.html(`
      <div class="js-SlidingBox-Call ui-SlidingBox-Call">
        <div class="box-full_width background-color_apporange shift-padding_2 text-align_center">
          <strong class="js-SlidingBox-CallCaption text-color_white box-inline-vertical_align_middle"
            data-ui-slidingbox-callcaption-collapsed="<span class='box-inline'>Pokaż ${count} inne wydarzenia z ${date}</span> <i class='icon-size_1-arrow_down-color_white box-inline'></i>"
            data-ui-slidingbox-callcaption-expanded="<span class='box-inline'>Ukryj ${count} inne wydarzenia</span> <i class='icon-size_1-triangle_top-color_white box-inline'></i>">
              <span class="box-inline">Pokaż ${count} inne wydarzenia z ${date}</span>
              <i class="icon-size_1-arrow_down-color_white box-inline"></i>
          </strong>
        </div>
      </div>
    `);
    const matches = this.model.get('matches');
    const sliced = matches.slice(1);
    sliced.reverse();
    sliced.forEach((model) => {
      const otherDayView = new OtherDayView(model);
      otherDayView.render();
      this.rootEl.prepend(otherDayView.getRootEl());
    });
  }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/event/other-days-view.js